import { clsx } from 'clsx';

import type { ReactElement } from 'react';
import type IChatStepIcon from '../interfaces/IChatStepIcon';

import styles from '../sass/AiChat.module.scss';

/**
 * The frame every step of a reply wears its icon in.
 *
 * The size, the shape and the colour live here alone, so a reasoning step and a tool call read as
 * the same kind of row, and a tool with an icon of its own still sits among them. The icon itself
 * is decorative: each step says what it is in the text beside this.
 */
function ChatStepIcon({ icon, className }: IChatStepIcon): ReactElement {
  return (
    <span className={clsx(styles.stepIcon, className)} data-chat-step-icon aria-hidden>
      {icon}
    </span>
  );
}

export default ChatStepIcon;
